<template>
  <div class="page-wrapper"  style="position: fixed; top:0; left:0; width: 100%; height: 100%; padding-top:0; color: #555;">
    <template v-if="merchantItem != false && merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.enabled !== undefined && merchantItem.webSetting.enabled == 1">
      <div class="top-nav-container" id="main-nav">
        <div class="container-fluid" style="margin: auto;">
          <div class="row">
            <div class="col-12" style="display: flex; height: 50px;">
              <div style="width: 80px;">
                <a href="#home">
                  <img v-if="merchantItem.webSetting.icon !== null && merchantItem.webSetting.icon.length > 0" :src="merchantItem.webSetting.icon" style="height: 48px;">
                  <span v-else>{{merchantItem.title}}</span></a>
              </div>
              <div style="width: calc(100% - 80px);" id="nav-container">
                <div class="nav-icon-container" id="nav-icon" @click="clickedOnNavIcon">
                  <div class="bar1"></div>
                  <div class="bar2"></div>
                  <div class="bar3"></div>
                </div>
                <div class="web-nav">

                  <!--                  <a href="#order" v-if="merchantItem.webOrder == 1">ORDER</a>-->
                  <a v-if="cateringSettings !== false && cateringSettings.cateringEnabled === true" href="#catering"  class="hover-underline-animation" @click="clickedOnNavIcon">CATERING</a>
                  <a href="#booking" class="hover-underline-animation" @click="clickedOnNavIcon" v-if="merchantItem.webSetting.useBooking === true">RESERVATION</a>
                  <a  v-else-if="merchantItem.webSetting.bookingExtUrl !== null && merchantItem.webSetting.bookingExtUrl.length > 0" class="hover-underline-animation" @click="moveToExtReservation">RESERVATION</a>
                  <a href="#menus" class="hover-underline-animation" @click="clickedOnNavIcon">MENUS</a>
                  <a href="#gallery" class="hover-underline-animation" @click="clickedOnNavIcon" v-if="merchantItem.webSetting.menuImages.length > 0">GALLERY</a>
                  <a href="#contact-us" class="hover-underline-animation" @click="clickedOnNavIcon">CONTACT US</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <div style="height: 100%; width: 100%; overflow-y: auto; scroll-behavior: smooth;" @scroll="handleScroll">
        <!--        <div style="width: 100%; position: sticky; top:0; background: white;z-index: 10;">-->
        <!--          <div class="container">-->
        <!--            <div class="row">-->
        <!--              <div class="col-12 text-left merchant-title">-->
        <!--                {{merchantItem.title}}-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div style="width: 100%; position: relative; background-repeat: no-repeat; background-position: center; background-size: cover;"
             class="home-main-image" id="home">
          <!--             v-bind:style="{backgroundImage: 'url(' + merchantItem.webSetting.imageUrls.split(',')[0] +')'}"-->



          <slider animation="fade" style="height:100%">
            <slider-item
              v-for="(img, index) in merchantItem.webSetting.imageUrls"
              :key="index"
              style="z-index: 0; height:100%;"


            >
              <div class="restaurant-main-image" v-bind:style="{backgroundImage: 'url(' + img + ')'}"></div>
            </slider-item>
          </slider>

          <div class="home-main-overlay">
            <div  class="home-main-subtitle" style="position: absolute; top:50%; left: 50%; transform: translate(-50%, -50%);  ">
              <!--            <div style="width: 100%; text-align: center; color: white;font-size: 30px; line-height: 55px; font-weight: bold; text-shadow: 2px 2px 8px gray; padding-top:30px;">{{merchantItem.webSetting.topMessage}}</div>-->
              <div class="home-main-title-image"
                   v-if="merchantItem.webSetting.titleImage !== undefined && merchantItem.webSetting.titleImage !== null && merchantItem.webSetting.titleImage.length > 0">

                <img :src="merchantItem.webSetting.titleImage"/>

              </div>
              <div class="home-main-title" v-else>
                {{merchantItem.title}}
              </div>
              <div class="home-main-description" style="width: 100%; text-align: center; color: white; margin-top: 11px;">
                {{merchantItem.webSetting.topMessageSmall}}
              </div>
              <div v-if="merchantItem.webOrder == 1" style="width: 100%; text-align: center; margin-top: 60px; height: 50px;">
                <a :href="'/order/' + merchantItem.merchantId + '/takeaway'"><span class="home-main-order-btn">Click & Collect Order</span></a>
              </div>
              <div v-if="merchantItem.webDelivery == 1" style="width: 100%; text-align: center; margin-top: 60px; height: 50px;">
                <a :href="'/order/' + merchantItem.merchantId + '/delivery'"><span class="home-main-order-btn">Delivery Order</span></a>
              </div>
              <div v-if="merchantItem.webSetting.bookingExtUrl !== null && merchantItem.webSetting.bookingExtUrl.length > 0" style="width: 100%; text-align: center; margin-top: 60px; height: 50px;">
                <span class="home-main-order-btn" @click="moveToExtReservation">RESERVATION</span>
              </div>
            </div>
          </div>
          <div style="position: absolute; bottom: 0; width: 100%; padding: 33px 0; text-align: center; background-color: #17161A; color: white;" v-if="merchantItem.webSetting.tempMessage !== null && merchantItem.webSetting.tempMessage.length > 0">
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="editor-message" v-html="merchantItem.webSetting.tempMessage">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container" style="margin-top: 50px;">
          <div class="row">
            <div class="col-12 col-md-12 " style="display: flex;align-items: center;justify-content: center; padding-bottom: 0;">
              <!--                <div class="webpage-section-header text-center">-->
              <!--                  ORDER NOW-->
              <!--                </div>-->
              <!--                <div style="display: flex;align-items: center;justify-content: center; padding-bottom: 30px;" v-if="merchantItem.webOrder == 1" >-->
              <!--                  <a :href="'/order/' + merchantItem.merchantId + '/takeaway'">-->
              <!--                    <div style="border-radius: 25px; background-color: #E4E4E4; padding:30px;font-size: 1.5rem; font-weight: bold; box-shadow: 5px 5px 5px gray;">-->
              <!--                      Click & Collect-->
              <!--                    </div>-->
              <!--                  </a>-->
              <!--                </div>-->

              <a v-if="merchantItem.webSetting.uberUrl !== null && merchantItem.webSetting.uberUrl.startsWith('https://')"
                 :href="merchantItem.webSetting.uberUrl"
                 target="_blank">
                <img style="width: 80px; height: 80px; border-radius: 25px; margin: 10px;" src="https://storage.googleapis.com/menus-275719.appspot.com/icons/uber-logo.png"/>
              </a>
              <a v-if="merchantItem.webSetting.deliverooUrl !== null && merchantItem.webSetting.deliverooUrl.startsWith('https://')"
                 :href="merchantItem.webSetting.deliverooUrl"
                 target="_blank">
                <img style="width: 80px; height: 80px; margin: 10px; border-radius: 25px;" src="https://storage.googleapis.com/menus-275719.appspot.com/icons/deliveroo-logo.png"/>
              </a>

            </div>
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="id-tagger"  id="about-us"></div>
          <div class="container web-section" style="max-width: 1000px;">
            <div class="row">
              <div class="col-12 text-center webpage-section-header">
                ABOUT US
                <div class="under-bar"></div>
              </div>
              <div class="col-12 webpage-section-content" style="padding-top: 28px;" v-html="merchantItem.webSetting.aboutUs.replace(/\n/g, '<br/>')">


                <!--                <span style="color: #FF5733; font-size: 30px;"><i class="fas fa-quote-left"></i></span><br/>-->

                <!--                <div style="padding-left: 30px;">-->
<!--                {{}}-->
                <!--                </div>-->
              </div>
            </div>
          </div>
          <div class="web-section gray-section">
            <div class="id-tagger"  id="booking"></div>
            <div class="container" v-if="merchantItem.webSetting.useBooking === true">
              <template v-if="bookingType === 0">
                <booking-view
                  :merchant-item="merchantItem">

                </booking-view>
              </template>
              <template v-else-if="bookingType === 1">
                <booking-table-view
                  :merchant-item="merchantItem">

                </booking-table-view>
              </template>
              <!--              <booking-view-->
              <!--                :merchant-item="merchantItem">-->
              <!--              </booking-view>-->
              <!--            <div class="row" v-if="bookingTypes.length > 1">-->
              <!--              <div class="col-12 booking-type-container" >-->
              <!--                <div class="booking-type" v-for="type in bookingTypes" v-bind:class="{'selected' : bookingItem.bookingType === type.title}" v-on:click="onTypeSelected(type.title)">-->
              <!--                  <div class="booking-type-title">-->
              <!--                    {{type.title}}-->
              <!--                  </div>-->
              <!--                  <div class="booking-type-description">-->
              <!--                    {{type.description}}-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </div>-->
              <!--            </div>-->
              <!--            <div class="row booking-form-row">-->

              <!--              <div class="col-12 col-md-4">-->
              <!--                <input class="form-control" type="date" v-model="bookingItem.bookingDate" v-on:change="onBookingDateSelected"></input>-->
              <!--              </div>-->
              <!--              <div class="col-12 col-md-4">-->
              <!--                <select class="form-control" v-model="bookingItem.bookingTime">-->
              <!--                  <option value="0">Select Time</option>-->
              <!--                  <option v-if="bookingItem.slots.length > 0" v-for="slot in bookingItem.slots" :value="slot.time" :disabled="slot.available === false">{{slot.text}}  {{slot.available === false?' Full':''}}</option>-->
              <!--                </select>-->
              <!--              </div>-->

              <!--              <div class="col-12 col-md-4">-->
              <!--                <select class="form-control" v-model="bookingItem.headCount">-->
              <!--                  <option value="0">Number of people</option>-->
              <!--                  <option v-for="(c, ci) in 20" :value="c">{{c}} People</option>-->
              <!--                </select>-->
              <!--              </div>-->
              <!--              <div class="col-12 col-md-4">-->
              <!--                <input class="form-control" type="text" v-model="bookingItem.name" placeholder="Name">-->
              <!--              </div>-->
              <!--              <div class="col-12 col-md-4">-->
              <!--                <input class="form-control" type="text" v-model="bookingItem.contact" placeholder="Mobile Number">-->
              <!--              </div>-->
              <!--              <div class="col-12 col-md-4">-->
              <!--                <input class="form-control" type="text" v-model="bookingItem.email" placeholder="Email">-->
              <!--              </div>-->
              <!--              <div class="col-12 text-left">-->
              <!--                Special Request-->
              <!--                <textarea class="form-control" rows="3" v-model="bookingItem.note"/>-->
              <!--              </div>-->
              <!--              <div class="col-12 text-right" v-if="canSubmitBooking() == true">-->
              <!--                <button class="btn btn-dark" v-on:click="submitBooking">Submit</button>-->
              <!--              </div>-->
              <!--            </div>-->
            </div>
          </div>
          <!--          <div class="container web-section" id="order" v-if="merchantItem.webOrder == 1 || (merchantItem.webSetting.uberUrl !== null && merchantItem.webSetting.uberUrl.startsWith('https://')) || (merchantItem.webSetting.deliverooUrl !== null && merchantItem.webSetting.deliverooUrl.startsWith('https://'))" >-->

          <!--          </div>-->
          <div class="container web-section" >
            <div class="id-tagger"  id="menus"></div>
            <div class="row" v-if="merchantItem.webSetting.menu_type === '1'">
              <div class="col-12 webpage-section-header text-center">
                MENUS
                <div class="under-bar"></div>
              </div>
              <div class="col-12 even-item-container"  style="">
                <button class="restaurant-menu-button" v-on:click="showMenus('dineIn')">Restaurant Menus</button>
                <!--              </div>-->
                <!--              <div class="col-12 col-md-6">-->
                <button class="restaurant-menu-button"  v-on:click="showMenus('takeaway')">Takeaway Menus</button>
              </div>
            </div>
            <div class="row" v-else-if="merchantItem.webSetting.menu_type === '2' && merchantItem.webSetting.menu_urls !== undefined && merchantItem.webSetting.menu_urls !== null && merchantItem.webSetting.menu_urls.length > 0">
              <div class="col-12 webpage-section-header text-center">
                MENUS
                <div class="under-bar"></div>
              </div>
              <div class="col-12 even-item-container">
                <div v-for="menu in merchantItem.webSetting.menu_urls" class="restaurant-menu-button" style="margin-left:10px; margin-right: 10px;" @click="openMenuFile(menu.url)">
                  <strong>{{menu.title}}</strong>
                </div>
              </div>


            </div>
          </div>
          <div class="web-section gray-section" v-if="cateringSettings !== false && cateringSettings.cateringEnabled === true">
            <div class="id-tagger" id="catering"></div>
            <div class="container">
              <div class="row">
                <div class="col-12 webpage-section-header text-center">
                  CATERING SERVICE
                  <div class="under-bar"></div>
                </div>

              </div>



            </div>
            <catering-service
              :merchant="merchantItem"
              :catering-settings="cateringSettings"/>
          </div>
          <div class="web-section dark-section" v-if="merchantItem.webSetting.menuImages.length > 0" >
            <div class="id-tagger"  id="gallery"></div>
            <div class="container" style="max-width: 1132px;">
              <div class="row">
                <div class="col-12">
                  <div class="webpage-section-header  text-center" >
                    GALLERY
                    <div class="under-bar white"></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6 col-md-4 web-gallery-item-container" v-for="img in merchantItem.webSetting.menuImages">
                  <div class="web-gallery-item" v-bind:style="{backgroundImage: 'url(' + getThumbnamil(img, '512') + ')'}"/>
                </div>
              </div>
            </div>
          </div>
          <div class="container web-section">
            <div class="id-tagger"  id="contact-us"></div>
            <div class="row">
              <div class="col-12 col-md-4">
                <div class="webpage-section-header smaller text-left" >
                  Contact Us
                </div>
                <div class="place-bottom-container" style="text-decoration: underline;">
                  <a :href="'tel:' + merchantItem.contact">{{merchantItem.contact}}</a>
                  <br/>
                  <a :href="'http://maps.google.com/?q=' + merchantItem.address" target="_blank" >{{merchantItem.address}}</a>
                  <br/>

                  <!--            <span v-if="merchantItem.distance != undefined"><i class="fas fa-map-marker"></i> {{Number(merchantItem.distance).toFixed(1)}} miles</span>-->
                </div>
                <div class="place-bottom-container" v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.moreContact.length > 0" v-html="merchantItem.webSetting.moreContact">

                </div>
              </div>
              <div class="col-12 col-md-4">
                <!--                <div class="round-box" style="margin:auto;">-->
                <div class="webpage-section-header smaller text-left">
                  Opening Hours
                </div>
                <div class="body text-left place-bottom-container">
                  <template  v-for="(day, di) in openingTime">
                    <div v-bind:key="'day-opening-hours-'+ di">
                      {{day.dayString}}:
                      <template v-if="day.open==false">
                        Closed
                      </template>
                      <template v-if="day.open == true && day.times != undefined && day.times.length > 0">
                        <span v-for="(time, ti) in day.times"><span v-if="ti>0">, </span>{{time.from}}~{{time.to}}</span>

                      </template>
                    </div>
                  </template>
                  <!--                  <table>-->
                  <!--                    <tr v-for="(day, di) in openingTime">-->
                  <!--                      <td style="width: 50%; vertical-align: top;">{{day.dayString}}</td>-->

                  <!--                      <td style="width: 50%; vertical-align: top; text-align: left;">-->
                  <!--                        <template v-if="day.open==false">-->
                  <!--                          Closed-->
                  <!--                        </template>-->
                  <!--                        <template v-if="day.open == true && day.times != undefined && day.times.length > 0">-->
                  <!--                          <span v-for="(time, ti) in day.times"><span v-if="ti>0">, </span>{{time.from}}~{{time.to}}</span>-->

                  <!--                        </template>-->
                  <!--                      </td>-->

                  <!--                    </tr>-->
                  <!--                  </table>-->
                </div>
                <!--                </div>-->
              </div>
              <div class="col-12 col-md-4">
                <div class="webpage-section-header smaller text-left">
                  Location
                </div>
                <div style="height: 300px;" id="mapName">
                  <iframe :src="merchantItem.webSetting.googleMap" width="100%" height="100%" frameborder="0" style="border:0"
                          allowfullscreen></iframe>
                </div>
              </div>
            </div>
            <div class="container" style="margin-top: 30px;" v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.bottomMessage !== null && merchantItem.webSetting.bottomMessage.length > 0">
              <div class="row">
                <div class="col-12" v-html="merchantItem.webSetting.bottomMessage">

                </div>
              </div>
            </div>
            <div class="container" style="margin-top: 50px;">
              <div class="row">
                <div class="col-12 col-md-12 " style="display: flex;align-items: center;justify-content: center; padding-bottom: 0;">
                  <!--                <div class="webpage-section-header text-center">-->
                  <!--                  ORDER NOW-->
                  <!--                </div>-->
                  <!--                <div style="display: flex;align-items: center;justify-content: center; padding-bottom: 30px;" v-if="merchantItem.webOrder == 1" >-->
                  <!--                  <a :href="'/order/' + merchantItem.merchantId + '/takeaway'">-->
                  <!--                    <div style="border-radius: 25px; background-color: #E4E4E4; padding:30px;font-size: 1.5rem; font-weight: bold; box-shadow: 5px 5px 5px gray;">-->
                  <!--                      Click & Collect-->
                  <!--                    </div>-->
                  <!--                  </a>-->
                  <!--                </div>-->

                  <a v-if="merchantItem.webSetting.uberUrl !== null && merchantItem.webSetting.uberUrl.startsWith('https://')"
                     :href="merchantItem.webSetting.uberUrl"
                     target="_blank">
                    <img style="width: 80px; height: 80px; border-radius: 25px; margin: 10px;" src="https://storage.googleapis.com/menus-275719.appspot.com/icons/uber-logo.png"/>
                  </a>
                  <a v-if="merchantItem.webSetting.deliverooUrl !== null && merchantItem.webSetting.deliverooUrl.startsWith('https://')"
                     :href="merchantItem.webSetting.deliverooUrl"
                     target="_blank">
                    <img style="width: 80px; height: 80px; margin: 10px; border-radius: 25px;" src="https://storage.googleapis.com/menus-275719.appspot.com/icons/deliveroo-logo.png"/>
                  </a>

                </div>
              </div>
            </div>
          </div>

        </div>

        <div style="width: 100%; background-color: #ECECEC; margin-top:0;">
          <div class="container" style="max-width: 440px;">
            <div class="row" style="padding-top:20px;padding-bottom: 20px;">
              <div class="col-12 ">
                <div class="external-link" style="width: 100%; display: flex;align-items: center;justify-content: center;">
                  <a v-if="merchantItem.webSetting.facebook !== null && (merchantItem.webSetting.facebook.startsWith('https://facebook.com') || merchantItem.webSetting.facebook.startsWith('https://www.facebook.com'))"
                     :href="merchantItem.webSetting.facebook" target="_blank">
                    <i class="fab fa-facebook"></i>
                  </a>

                  <a v-if="merchantItem.webSetting.instagram !== null && (merchantItem.webSetting.instagram.startsWith('https://www.instagram.com') || merchantItem.webSetting.instagram.startsWith('https://instagram.com'))"
                     :href="merchantItem.webSetting.instagram" target="_blank">
                    <i class="fab fa-instagram"></i>
                  </a>

                  <a v-if="merchantItem.webSetting.youtube !== null && (merchantItem.webSetting.youtube.startsWith('https://www.youtube.com') || merchantItem.webSetting.youtube.startsWith('https://youtube.com'))"
                     :href="merchantItem.webSetting.youtube" target="_blank">
                    <i class="fab fa-youtube"></i>
                  </a>
                </div>
              </div>
              <!--              <div class="col-6 col-md-2 external-link" style="vertical-align: center; font-size: 30px; line-height: 50px;">-->
              <!--                -->
              <!--              </div>-->
              <!--              <div class="col-6 col-md-2 external-link" style="vertical-align: center; font-size: 30px; line-height: 50px;">-->
              <!--               -->
              <!--              </div>-->

              <!--              <div class="col-6 col-md-2 external-link" style="vertical-align: center; font-size: 30px; line-height: 50px;">-->
              <!--               -->
              <!--              </div>-->
              <!--              <div class="col-6 col-md-2" style="vertical-align: center; font-size: 30px; line-height: 50px;">-->
              <!--                <i class="fab fa-tiktok"></i>-->
              <!--              </div>-->
            </div>
            <div class="row">
              <div class="col-12 text-center" style="font-size: small;">
                <div style="width: 120px; margin:auto;">
                  <img style="width:80px;" :src="merchantItem.webSetting.icon"/>
                </div>
              </div>
              <div class="col-12 text-center" style="display: none;">
                <div>
                  <!--                  <template v-if="merchantItem.registeredTitle != undefined && merchantItem.registeredTitle != null && merchantItem.registeredTitle.length > 0">-->
                  <!--                    <strong>{{merchantItem.registeredTitle}}</strong> trade as-->
                  <!--                  </template>-->
                  <strong>{{merchantItem.title}}</strong><br>{{merchantItem.contact}}<br><span v-html="merchantItem.address.replace(/\n/g, '<br />')"></span>
                </div>

              </div>

              <!--              <div class="col-6 text-left tnc-btn" style="font-size:  x-small">-->
              <!--                <span v-on:click="openTnc">Terms & Conditions</span>-->
              <!--              </div>-->

              <div class="col-12" style="font-size:  small; margin-top:20px;">
                Copyright @2021 <strong>{{merchantItem.title}}</strong>. All rights reserved
              </div>


              <div class="col-12"  style="font-size:  small; margin-top:20px;" v-if="merchantItem.webSetting.footerMessage !== null && merchantItem.webSetting.footerMessage.length > 0">
                <div v-html="merchantItem.webSetting.footerMessage"></div>
              </div>
              <div class="col-12" style="padding-top:20px; padding-bottom: 30px;">
                Powered by <strong>Show Me The Menu</strong>
                <br/>
                Borium Studio Limited
              </div>
              <!--              <div class="col-12" style="font-size:  x-small">-->
              <!--                Powered by <strong><span v-if="isEemo">EEMO & GOMO</span><span v-else>Show Me The Menu</span></strong>-->
              <!--                <template v-if="isEemo==false"><br>Borium Studio Limited</template>-->
              <!--              </div>-->

            </div>
          </div>
        </div>
      </div>


    </template>
    <template v-else-if="merchantItem != false">
    <div style="height: 100%; width: 100%; max-width: 450px; margin: auto; overflow-y: scroll; position: relative;" v-if="merchantItem != false">
      <div class="left-top-back level-3" id="back-btn" v-on:click="closeTop">
        <span><i class="fas fa-arrow-left"></i></span>
      </div>
      <div class="place-container" :key="'m-'+merchantItem.merchantId" v-if="merchantItem.merchantId > 0">
        <div class="place-image-container" v-bind:style="{backgroundImage : 'url(' + merchantItem.imageUrl.split(',')[0] + ')'}">
          <div class="place-out-of-hours" v-if="merchantItem.isOpen == false">Out of opening hours</div>
        </div>

        <div class="place-info-container">
          <div class="place-header">
            <div class="place-title-container">
              {{merchantItem.title}}
            </div>
            <div class="place-service-container">
              <span v-if="merchantItem.webOrder == 1">Takeaway</span>
              <span v-if="merchantItem.webDelivery == 1">Delivery</span>
            </div>
          </div>

          <div class="place-tag-container">
            {{merchantItem.types}}
          </div>
          <div class="place-bottom-container">
            <i class="fas fa-map-marker"></i> <a :href="'http://maps.google.com/?q=' + merchantItem.address" target="_blank" >{{merchantItem.address}}</a>
            <br>
            <i class="fas fa-phone"></i> <a :href="'tel:' + merchantItem.contact">{{merchantItem.contact}}</a>
<!--            <span v-if="merchantItem.distance != undefined"><i class="fas fa-map-marker"></i> {{Number(merchantItem.distance).toFixed(1)}} miles</span>-->
          </div>

          <div class="container">
            <div class="row">
              <div class="col-12" style="line-height: 80px;">
                Please choose the way you order
              </div>
            </div>
            <div class="row">
              <div class="col-4" v-for="menu in mainMenus" v-if="menu.enabled == true" v-on:click="moveToCustomSite(menu.mode)">
                <div class="square-icon" v-bind:style="{backgroundImage: 'url(' + menu.url + ')'}"></div>
                <div class="icon-title">{{menu.name}}</div>
              </div>

            </div>
          </div>

          <div class="round-box">
            <div class="header">
              Opening Hours
            </div>
            <div class="body">
              <table>
                <tr v-for="(day, di) in openingTime">
                  <td style="width: 35%;">{{day.dayString}}</td>

                  <td style="width: 65%;">
                    <template v-if="day.open==false">
                      Closed
                    </template>
                    <template v-if="day.open == true && day.times != undefined && day.times.length > 0">
                      <span v-for="(time, ti) in day.times"><span v-if="ti>0">, </span>{{time.from}}~{{time.to}}</span>

                    </template>
                  </td>

                </tr>
              </table>
            </div>
          </div>

        </div>


      </div>

<!--      <Bottom :item="merchantItem"></Bottom>-->
    </div>
    </template>
    <transition name="vertical">
      <div v-if="popupImage !== false && popupImage !== null && popupImage.length > 0"
      style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.4); z-index: 999;" @click="popupImage = false">
        <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: calc(100% - 30px); max-width: 500px; max-height: 90%; background: white; overflow-y: auto; box-shadow: 5px 5px 5px #333; border-radius: 20px;" @click.stop="dummy">
          <img :src="popupImage" style="width: 100%;"/>
          <div style="height: 50px; width: 100%; line-height: 50px; text-align: center; font-size: 20px; font-weight: bold;" @click.stop="popupImage = false">
            Close
          </div>
        </div>
      </div>
    </transition>
    <transition name="vertical">
    <div v-if="menuView != false" style="position: absolute; z-index: 11; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.4);" v-on:click="menuView = false">
      <div style="position: absolute; width: calc(100% - 20px); max-width: 800px; height: calc(100% - 20px); border-radius: 10px; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white;" v-on:click.stop="dummy">
        <menu-view
          :merchant="menuView.merchant"
          :type="menuView.type"
          :on-close="closeMenuView"></menu-view>
      </div>
    </div>
    </transition>

    <v-dialog/>
  </div>
</template>

<script>
  import EventBus from "../api/event-bus";

  import Bottom from "./Bottom";
  require('@/assets/css/styles.css')

  import {
    getBookingTimeTable, getBookingTypes,
    getHolidayList,
    getMerchant, getMerchantSettings,
    getBookingSlots,
    submitBooking,
    submitLog
  } from "../api/borium";
  import Router from '../router';
  import {Slider, SliderItem} from "vue-easy-slider";
  import {millisToDate} from "../api/utils";
  import MenuView from "./MenuView";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import BookingView from "./BookingView.vue";
  import BookingTableView from "./BookingTableView.vue";
  import CateringService from "./CateringService.vue";
    export default {
        name: "Place",
      data() {
        return {
          animDuration: 300,
          mainMenus: [
            {
              name: "Collect",
              url: "/static/img/ic-collect.png",
              description: "Order and Collect.",
              mode: 'takeaway',
              enabled:true,
            },
            {
              name: "Delivery",
              url: "/static/img/ic-delivery.png",
              description: "Simply order and We will deliver",
              mode: 'delivery',
              enabled:true,
            },
            {
              name: "QRCode",
              url: "/static/img/ic-qrcode.png",
              description: "Simply scan QR Code on table.",
              mode: 'qrCode',
              enabled:true,
            },

            // {
            //     name:"자동주문 예약",
            //     url:"https://sj-eemo.s3.ap-northeast-2.amazonaws.com/web/ic-auto.png",
            //     description:"생활패턴에 맞춘 자동 주문해보세요.",
            //     mode:3,
            // },


          ],
          commonDomain: true,
          merchantId:0,
          merchantItem:false,
          images:[],
          openingTime:[],
          deliveryTime:false,
          bookingDaySchedules: [],
          bookingTypes:[],
          bookingItem:false,
          menuView:false,
          holidays:[],
          editHoliday:false,
          bookingType:0,
          popupImage:false,
          cateringSettings:false,
        }
      },
      components: {
        BookingTableView, BookingView,
        Slider,
        SliderItem,
        Bottom,
        MenuView,
        DatePicker,
        CateringService
      },
      created() {
        // console.log("URL: " + window.location.host)
        // if(window.location.host !== 'eemo.app' && window.location.host !== 'showmethemenu.net' && window.location.host !== 'localhost:8090' && window.location.host !== '10.0.100.3:8090') {
        //   this.$data.commonDomain = false;
        //
        // }
        this.getMerchantItem();
      },
      mounted() {
        if(this.$data.commonDomain == true) {
          EventBus.$emit("setTitle", "");
        } else {
          EventBus.$emit("setTitle", "Hi");
        }
        EventBus.$emit("modeChanged", 0);
        $("#nav-top").removeClass("transparent-background");
      },
      methods: {
        dummy: function() {

        },
        closeTop: function() {
          // console.log("close top");
          // if(this.$data.currentPath !== this.$data.basePath) {
          this.$router.go(-1);
          // }
        },
        getMerchantItem: function() {
          // console.log(this.$route.params);
          let id = 0;
          if(this.$route.params.hasOwnProperty('id')) {
            id = this.$route.params.id;
          }
          // let url = 'https://' + window.location.host;
          // if(window.location.host.startsWith('localhost')) {
          //   url = 'http://' + window.location.host;
          // }
          let self = this;
          getMerchant(id)
            .then(function(data) {
              // console.log(data);
              if(data.success) {
                if(data.item.webSetting !== undefined && data.item.webSetting !== null) {
                  if(data.item.webSetting.imageUrls !== undefined && data.item.webSetting.imageUrls !== null && data.item.webSetting.imageUrls.length > 0) {
                    let images = data.item.webSetting.imageUrls.split(",");
                    // for(let i = 0 ; i < images.length ; i++) {
                    //   let fileNames = images[i].split(".");
                    //   let fileExt = "." + fileNames[fileNames.length-1];
                    //   images[i] = images[i].replace(fileExt, "_512x512" + fileExt);
                    // }
                    data.item.webSetting.imageUrls = images;
                    // data.item.webSetting.imageUrls = data.item.webSetting.imageUrls.split(",");
                  } else {
                    data.item.webSetting.imageUrls = [];
                  }
                  if(data.item.webSetting.menuImages !== undefined && data.item.webSetting.menuImages !== null && data.item.webSetting.menuImages.length > 0) {
                    data.item.webSetting.menuImages = data.item.webSetting.menuImages.split(",");
                  } else {
                    data.item.webSetting.menuImages = [];
                  }
                  if(parseInt(data.item.webSetting.useBooking) == 1) {
                    data.item.webSetting.useBooking = true;
                  } else {
                    data.item.webSetting.useBooking = false;
                  }
                  if(data.item.webSetting.menu_urls !== undefined && data.item.webSetting.menu_urls !== null && data.item.webSetting.menu_urls.length > 0) {
                    data.item.webSetting.menu_urls = JSON.parse(data.item.webSetting.menu_urls);
                  } else {
                    data.item.webSetting.menu_urls = [];
                  }

                  if(data.item.webSetting.popupImage !== undefined && data.item.webSetting.popupImage !== null && data.item.webSetting.popupImage.length > 0) {
                    self.$data.popupImage = data.item.webSetting.popupImage;
                  }
                }
                self.$data.bookingType = parseInt(data.item.tableBooking);
                self.$data.merchantItem = data.item;
                // console.log("merchant item");
                // console.log(self.$data.merchantItem);
                self.setMerchant();
              }
            })
            .catch(function(err) {
              console.error('Request failed', err && err.response ? err.response.status : '');
            })

        },
        getMerchantSettings: function() {
          let self = this;
          // console.log("Get web catering inquiry setting " + this.$data.merchantItem.merchantId);
          getMerchantSettings(this.$data.merchantItem.merchantId, 'cateringInquiry')
            .then(function(data) {
              // console.log(data);
              if(data.success === true) {

                let cateringSettings = {};
                for(let i = 0 ; i < data.item.length ; i++) {
                  // console.log(data.item[i]);
                  if(data.item[i].valueType === 'boolean') {
                    cateringSettings[data.item[i].field] = data.item[i].boolVal;
                  } else if(data.item[i].valueType === 'text'|| data.item[i].valueType === 'textarea') {
                    cateringSettings[data.item[i].field] = data.item[i].textVal;
                  } else if(data.item[i].valueType === 'images') {
                    cateringSettings[data.item[i].field] = data.item[i].list;
                  }
                }
                // console.log("catering inquiry");
                if(cateringSettings.cateringEnabled !== undefined && cateringSettings.cateringEnabled === true) {
                  self.$data.cateringSettings = cateringSettings;
                }
                // console.log(self.$data.cateringSettings);
              }
            })
            .catch(function(err) {
              console.error('Request failed', err && err.response ? err.response.status : '');
            })
        },
        setMerchant: function() {
          EventBus.$emit("setTitle", this.$data.merchantItem.title);
          this.$data.images = this.$data.merchantItem.imageUrl.split(',');

          if(this.$data.merchantItem.webDelivery == 0) {
            this.$data.mainMenus[1].enabled = false;
          }
          if(this.$data.merchantItem.webTable == 0) {
            this.$data.mainMenus[2].enabled = false;
          }
          if(this.$data.merchantItem.webOrder == 0) {
            this.$data.mainMenus[0].enabled = false;
          }
          if(this.$data.merchantItem.openingTime != null && this.$data.merchantItem.openingTime.length > 3) {
            this.$data.openingTime = JSON.parse(this.$data.merchantItem.openingTime);
          }
          // console.log(this.$data.merchantItem.deliveryTime);
          if(this.$data.merchantItem.deliveryTime != null && this.$data.merchantItem.deliveryTime.length > 3) {

            this.$data.deliveryTime = JSON.parse(this.$data.merchantItem.deliveryTime);
          }


          this.setPageMeta();
          this.getBookingInfo();

          // console.log("set gtags now");
          // setGTags('UA-170143968-1');

          // console.log('load script now');
          // this.loadGScript('UA-170143968-1');
          submitLog(this.$data.merchantItem.merchantId, 'PlacePage', "")
          .then(function(data) {

          })
          .catch(function(err){

          })
          this.getMerchantSettings();
        },
        loadGScript: function(id) {
          // console.log("load script starts");
          let recaptchaScript = document.createElement('script')
          recaptchaScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=' + id)
          // console.log("load script starts appending to head " + recaptchaScript);
          document.head.appendChild(recaptchaScript)
          // console.log("load script appended to head " + recaptchaScript);
          // console.log("appended");
        },
        changeCurrentModeAnim: function(newMode) {
          // console.log("changeCurrentModeAnim");
          setTimeout(this.changeCurrentMode, this.$data.animDuration, newMode);
        },
        moveToCustomSiteAnim: function(newMode) {
          setTimeout(this.moveToCustomSite, this.$data.animDuration, newMode);
        },
        moveToCustomSite: function(newMode) {
          if(newMode == 'qrCode') {
            EventBus.$emit("startScanner");
            return;
          }
          Router.push('/order/' + this.$data.merchantItem.merchantId + '/' + newMode);
        },
        changeCurrentMode: function(newMode) {
          if(newMode == 'qrCode') {
            EventBus.$emit("startScanner");
            return;
          }
          Router.push('/home?mode='+newMode);
        },
        codeScanned: function(code) {
          // console.log("code Scanned " + code)
          let obj = JSON.parse(code);
          if(obj != null) {
            if(obj.tableId != undefined) {
              Router.push('/restaurant?table='+obj.tableId);
            }
          }
        },
        setPageMeta: function() {
          const titleEl = document.querySelector('head title');
          const descEl = document.querySelector('head meta[name="description"]');
          const keywordsEl = document.querySelector('head meta[name="keywords"]');

          let title =this.$data.merchantItem.title;
          let key = this.$data.merchantItem.title;

          let description = "Simple click and collect & Takeaway and delivery order for " + this.$data.merchantItem.title;
          if(this.$data.merchantItem.region !== undefined && this.$data.merchantItem.region != null && this.$data.merchantItem.region.length > 0) {
            title += " in " + this.$data.merchantItem.region;
            key += "," + this.$data.merchantItem.region;
            description += " in " + this.$data.merchantItem.region;
          }
          key += ", takeaway, delivery";
          if(this.$data.merchantItem.tags !== undefined && this.$data.merchantItem.tags != null && this.$data.merchantItem.tags.length > 0) {
            key += "," + this.$data.merchantItem.tags;
          }
          title += " Takeaway | Delivery | Menu | Price | Show Me The Menu";
          titleEl.textContent = title;

          descEl.setAttribute('content', description);
          keywordsEl.setAttribute('content', key);

          if(this.$data.merchantItem.webSetting !== undefined
            && this.$data.merchantItem.webSetting != null
            && this.$data.merchantItem.webSetting.icon != null
          && this.$data.merchantItem.webSetting.icon.startsWith("https://")) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
              link = document.createElement('link');
              link.rel = 'icon';
              document.getElementsByTagName('head')[0].appendChild(link);
            }
            link.href = this.$data.merchantItem.webSetting.icon;
          }
        },

        getBookingInfo: function() {
          let self = this;
          getBookingTypes(this.$data.merchantItem.merchantId)
          .then(function(data){
            if(data.success === true) {
              self.$data.bookingTypes = data.item;
            }
            self.getBookingTimes();
          })
          .catch(function(err) {

          })
        },
        getBookingTimes: function() {
          let self = this;
          getBookingTimeTable(this.$data.merchantItem.merchantId)
          .then(function(data) {
            if(data.success === true) {
              self.$data.bookingDaySchedules = data.item;
              // console.log(data.item);
              self.$data.bookingItem = {
                bookingDate:'',
                bookingDayTime:'',
                bookingTime:0,
                bookingType:self.$data.bookingTypes.length === 1 ? self.$data.bookingTypes[0].title : '',
                name:'',
                headCount:0,
                email:'',
                note:'',
                contact:'',
                subscriptionId:self.$data.merchantItem.merchantId,
                slots:[],
              }
              self.getHolidayList();
            }

          })
          .catch(function(err) {

            console.error('Request failed', err && err.response ? err.response.status : '');
          })
        },
        getHolidayList: function() {
          // console.log("get holiday list");
          let self = this;
          let today = millisToDate(new Date().getTime(), '-');

          getHolidayList(this.$data.merchantItem.merchantId, today)
          .then(function(data) {
            // console.log("holiday response");
            // console.log(data);
            if(data.success === true) {
              self.$data.holidays = data.item;
            }
          })
          .catch(function(err) {
            console.error('Request failed', err && err.response ? err.response.status : '');
          })
        },
        canSubmitBooking: function() {
          // console.log("check submittable")
          if(this.$data.bookingItem == null || this.$data.bookingItem === false) {

            return false;
          }

          let todayText = millisToDate();
          if(this.$data.bookingItem.bookingDate === undefined || this.$data.bookingItem.bookingDate === null
            || this.$data.bookingItem.bookingDate === '' || this.$data.bookingItem.bookingDate === '0000-00-00'
          ||this.$data.bookingItem.bookingDate < todayText ) {
            return false;
          }

          if(this.$data.bookingItem.bookingTime == 0) {
            return false;
          }

          if(this.$data.bookingItem.name === null || this.$data.bookingItem.name === '' || this.$data.bookingItem.name.length < 2) {
            return false;
          }
          if(this.$data.bookingItem.headCount === 0) {
            return false;
          }
          if(this.$data.bookingItem.contact === null || (this.$data.bookingItem.contact.startsWith("44") == false && this.$data.bookingItem.contact.startsWith("07") == false)) {
            return false;
          }
          if(this.$data.bookingItem.email === null || this.$data.bookingItem.email.includes("@") == false) {
            return false;
          }
          return true;
        },
        submitBooking: function() {
          if(this.canSubmitBooking()==false) {
            return;
          }

          for(let i = 0 ; i < this.$data.bookingItem.slots.length ; i++) {
            if(this.$data.bookingItem.slots[i].time === this.$data.bookingItem.bookingTime) {
              this.$data.bookingItem.bookingDayTime = this.$data.bookingItem.slots[i].text;
              break;
            }
          }

          EventBus.$emit("showLoading", true, "Submitting...");
          let self = this;
          submitBooking(this.$data.bookingItem)
          .then(function(data) {
            EventBus.$emit("showLoading", false);
            if(data.success === true) {
              self.showDialog(data.message);
              self.$data.bookingItem = {
                bookingDate:'',
                bookingDayTime:'',
                bookingTime:0,
                name:'',
                headCount:0,
                email:'',
                note:'',
                contact:'',
                subscriptionId:self.$data.merchantItem.merchantId,
                slots:[],
              }
            } else {
              self.showDialog(data.message);
            }
          })
          .catch(function(err) {
            EventBus.$emit("showLoading", false);

            console.error('Request failed', err && err.response ? err.response.status : '');
            self.showDialog("There was an error. Please check email if you received email.", "Something went wrong!");
          })
        },
        onTypeSelected: function(type) {
          if(type === this.$data.bookingItem.bookingType) {
            return;
          }
          this.$data.bookingItem.bookingType = type;
          this.$data.bookingItem.bookingDate = null;
          this.$data.bookingItem.slots = [];
          this.$data.bookingItem.bookingTime = 0;
        },
        onBookingDateSelected: function() {
          if(this.$data.bookingItem.bookingDate === undefined || this.$data.bookingItem.bookingDate === null
            || this.$data.bookingItem.bookingDate === '' || this.$data.bookingItem.bookingDate === '0000-00-00') {
            this.$data.bookingItem.bookingDate = null;
            return false;
          }
          this.$data.bookingItem.slots = [];
          this.$data.bookingItem.bookingTime = 0;
          this.loadLondonSlots();
        },
        loadLondonSlots: function() {
          let self = this;
          getBookingSlots(this.$data.merchantItem.merchantId, this.$data.bookingItem.bookingDate, this.$data.bookingItem.bookingType)
            .then(function(data) {
              if(data.success !== true || data.item == null) {
                self.$data.bookingItem.bookingDate = null;
                self.$data.bookingItem.slots = [];
                self.showDialog(data.message || "This date is not available");
                return;
              }
              let list = data.item;
              self.$data.bookingItem.slots = list.slots || [];
              if(list.deposit > 0) {
                self.$data.bookingItem.depositPerPerson = list.deposit;
                self.$data.bookingItem.deposit = list.deposit;
              }
            })
            .catch(function(err) {
              console.error('Request failed', err && err.response ? err.response.status : '');
              self.$data.bookingItem.bookingDate = null;
              self.showDialog("There was an error. Please try again.");
            })
        },

        showMenus: function(type) {
          this.$data.menuView = {
            merchant: this.$data.merchantItem,
            type:type,
          }
        },
        closeMenuView: function() {
          this.$data.menuView = false;
        },
        showDialog: function(message, title = '') {
          let params = {
            title:title,
            text:message
          }
          this.$modal.show('dialog', params);
        },
        getThumbnamil: function(url, size = 300) {
          if(url.startsWith("https://storage.googleapis.com/menus-275719.appspot.com/merchants/menus") || url.startsWith("https://storage.googleapis.com/menus-275719.appspot.com/webs/")) {
            let words = url.split('.');
            words[words.length-2] += '_' + size + 'x' + size;
            return words.join('.');
          }
          return url;
        },
        openMenuFile: function(url) {
          window.open(url, '_blank');
        },
        moveToExtReservation: function() {
          if(this.$data.merchantItem.webSetting.bookingExtUrl !== null && this.$data.merchantItem.webSetting.bookingExtUrl.length > 0) {
            window.open(this.$data.merchantItem.webSetting.bookingExtUrl, '_blank');
          }
        },
        clickedOnNavIcon: function() {

          document.getElementById("nav-container").classList.toggle("mobile-nav-show");
        },
        handleScroll(event) {
          // console.log(event.srcElement.scrollTop);
          if(this.$data.scrollingPosition < 300 && event.srcElement.scrollTop > 300) {

            if(document.getElementById("main-nav").classList.contains("dark") === false) {
              document.getElementById("main-nav").classList.add("dark");
            }
          } else if(this.$data.scrollingPosition > 300 && event.srcElement.scrollTop < 300) {
            if(document.getElementById("main-nav").classList.contains("dark") === true) {
              document.getElementById("main-nav").classList.remove("dark");
            }
          }
          this.$data.scrollingPosition = event.srcElement.scrollTop;
        },
      },

    }
</script>

<style scoped>
.home-main-image {
  height: 670px;
}
.home-main-subtitle {
  font-size: 30px;
  padding:50px;
  width: 100%;
}
@media only screen and (max-width: 430px) {
  .home-main-image {
    height: 600px;
  }
  .home-main-subtitle {
    width: 90%;
    font-size: 15px;
    padding:10px;
  }
}

.top-nav-container {
  width: 100%; position: absolute; padding: 20px; z-index: 10;
  color:white;
  background-color: transparent;
  transition: background-color 0.5s ease-in-out;
}
.top-nav-container.dark {
  background-color: rgba(0,0,0,1);
}
@media only screen and (max-width: 500px) {
  .top-nav-container {
    padding: 20px 0;
  }
}
.home-main-overlay {
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.4);
}

.home-main-title {
  font-weight: 400;
  font-size: 40px;
  line-height: 48px;
  /* identical to box height */

  text-align: center;
  letter-spacing: 0.3em;
  margin-right: -0.3em;

  color: #FFFFFF;
}
.home-main-description {
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height */

  text-align: center;
  letter-spacing: 0.2em;
  margin-right: -0.2em;

  color: #FFFFFF;
}
.home-main-order-btn {
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height */

  text-align: center;
  letter-spacing: 0.2em;

  color: #000000;
  background: #FFFFFF;
  padding: 18px 25px;
  transition: background-color 0.3s ease-in-out;

  cursor: pointer;
}
.home-main-order-btn:hover {
  background-color: #DBDBDB;
}
@media only screen and (max-width: 500px) {
  .home-main-title{
    font-size: 30px;
  }
  .home-main-description {
    font-size: 18px;
  }
  .home-main-order-btn {
    font-size: 14px;
  }
}
.restaurant-menu-button {
  border: 1px solid #000000;
  background-color: white;
  width: 300px;
  padding: 24px 0;
  font-weight: 500;
  font-size: 18px;
  line-height: 36px;
  /* identical to box height */

  text-align: center;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  cursor: pointer;
  color: #000000;
  margin: 10px;

}
.restaurant-menu-button:hover {
  background-color: #ECECEC;
}
a {
  text-decoration: none;
  color: inherit;
}
.even-item-container {
  display: flex; align-items: center; justify-content: center;
}
@media only screen and (max-width: 430px) {
  .even-item-container {
    display: block;
  }
  .even-item-container .restaurant-menu-button {
    margin:10px auto 10px auto;
    padding: 20px 0;
    width: calc(100% - 32px);
    text-align: center;
    font-size: 18px;

  }

}
.home-main-title-image {
  text-align: center;
  padding: 20px;
}
.home-main-title-image img {

  width: 100%;
  max-width: 350px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Place.vue